import { apiClient } from '@/services/api';
import { Observable, from, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';
import IProfile, { IPermission } from '@/interfaces/profiles';

function getProfiles(filter?: {}): Observable<IProfile[]> {
  return from(apiClient.get(ENDPOINTS.PROFILE, filter)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

function getProfile(id: string): Observable<IProfile> {
  return from(apiClient.get(`${ENDPOINTS.PROFILE}/${id}`)).pipe(
    map((r: any) => r.data),
  );
}

function saveProfile(payload: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.PROFILE, payload)).pipe(
    map((r: any) => r.data),
  );
}

function updateProfile(payload: any): Observable<any> {
  return from(apiClient.put(ENDPOINTS.PROFILE, payload)).pipe(
    map((r: any) => r.data),
  );
}

function getPermissions(): Observable<IPermission[]> {
  return from(apiClient.get(ENDPOINTS.PERMISSION)).pipe(
    map((r: any) => (!!r.data ? r.data : [])),
  );
}

export { getProfiles, getProfile, saveProfile, updateProfile, getPermissions };
